module.exports = __webpack_public_path__ + "img/youtube-line-dark.c7bad6c.svg";